import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { POST_SELECTED_WHEN, POST_USER_DATA } from "../../store/action";
import { GET } from "../constants/request-type";
import { service_api } from "../constants/url";
import { MakeRequestAsync } from "../functions/axios";
import { decryptSingleData } from "../functions/cryptojs";
import { dayPlusOne } from "../functions/dateFunctions";
import "../styles/layout.css";

// image importation

import { configureCrisp } from "../../utils/crispConfig";
import { createLogger } from "../../utils/logger";
import SectionChef from "../elements/section-chef";

const logger = createLogger("LayoutIamChef");
const LayoutIamChef = () => {
  const [load, setLoad] = useState(true);

  let user = useSelector((state) => state.user);
  let selectedLang = useSelector((state) => state.lang);

  const dispatch = useDispatch();

  const post_user_data = (data) => {
    dispatch(post_user(data));
  };

  useEffect(() => {
    configureCrisp({
      autoload: true,
      lockMaximized: false,
      lockFullview: false
    });
    initialData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const initialData = async () => {
    const tday = dayPlusOne();
    WhenDate(tday);

    // reload user data and also check for token
    // Skip user data fetch for local development if no user is available
    if (!user || !user._id || !user.refresh_token) {
      logger.log("No user data available for local development");
      setLoad(false);
      return;
    }

    const request_details = {
      type: GET,
      url: service_api,
      route: `user/get-one/${user?._id}`,
      data: null,
      token: user?.refresh_token
    };

    try {
      const response = await MakeRequestAsync(request_details);
      post_user_data(decryptSingleData(response.data.user));
    } catch (err) {
      logger.log("User data fetch failed:", err);
      // Disable logout and reload for local development
    
    } finally {
      setLoad(false);
    }
  };

  const WhenDate = (value) => dispatch(post_selected_when(value));


  if (load) {
    return (
      <div className="global-block">
        <div
          className="full-block"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh"
          }}
        >
          <div>Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="global-block">
      <div className="full-block">
        {/* Tu dois ajouter tout les autre compasant du projet ici */}
        <SectionChef />
      </div>
    </div>
  );
};

export default LayoutIamChef;

const post_user = (data) => ({
  type: POST_USER_DATA,
  data: data
});

const post_selected_when = (data) => ({
  type: POST_SELECTED_WHEN,
  data: data
});
